import React, { useEffect, useState, useMemo, useCallback } from "react";
import MyProfileDetails from "./MyProfileDetails";
import { getCurrentUser } from "../../app/store/auth";
import {
  useGetUserDetailsQuery,
  useGetPartnerUserDetailsQuery,
  useGetUserProfilePicQuery,
  useUpdateProfileDataMutation,
  useUploadProfilePicMutation,
} from "../../app/store/authApiSlice";
import { getAlert } from "../../Services/appAlerts";
import { Modal } from "react-bootstrap";

const PROFILE_STYLES = {
  modalContent: {
    borderRadius: "24px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)"
  },
  modalDialog: {
    maxWidth: "1040px"
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)"
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    paddingRight: "0"
  },
  modalFooter: {
    padding: "16px 22px 20px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
  },
  modalTitleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px"
  },
  modalIcon: {
    width: "44px",
    height: "44px",
    borderRadius: "14px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
    color: "#0f172a",
    fontSize: "20px",
    boxShadow: "none"
  },
  modalEyebrow: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#4f46e5",
    marginBottom: "4px"
  },
  modalTitle: {
    fontSize: "21px",
    fontWeight: 600,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0
  },
  modalSubtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px"
  },
  modalBody: {
    padding: "20px 22px 22px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
    minHeight: "420px",
    maxHeight: "calc(100vh - 220px)",
    overflowY: "auto",
    overflowX: "hidden"
  },
  editButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  editButtonHeader: {
    flexShrink: 0
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexShrink: 0
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "10px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    flexShrink: 0
  },
  cancelButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  bodyGrid: {
    display: "grid",
    gridTemplateColumns: "240px minmax(0, 1fr)",
    gap: "16px"
  },
  avatarPanel: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "18px 16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center"
  },
  avatarRing: {
    width: "122px",
    height: "122px",
    borderRadius: "999px",
    padding: "6px",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.18) 0%, rgba(79, 70, 229, 0.22) 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  avatarImage: {
    width: "110px",
    height: "110px",
    objectFit: "cover",
    borderRadius: "999px",
    border: "4px solid #ffffff",
    backgroundColor: "#f8fafc"
  },
  avatarName: {
    marginTop: "14px",
    fontSize: "17px",
    fontWeight: 600,
    color: "#0f172a"
  },
  avatarMeta: {
    marginTop: "5px",
    fontSize: "12px",
    color: "#64748b",
    lineHeight: 1.5
  },
  uploadHint: {
    marginTop: "12px",
    fontSize: "12px",
    color: "#64748b",
    lineHeight: 1.55
  },
  cameraButton: {
    marginTop: "14px",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    padding: "9px 18px",
    background: "#ffffff",
    color: "#334155",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
    border: "1px solid #cbd5e1",
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    transition: "all 0.2s ease"
  },
  cameraButtonDisabled: {
    opacity: 0.55,
    cursor: "not-allowed"
  },
  detailsPanel: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "18px"
  }
};

export default function Profile(props) {
  const { profileShowHide, handleProfileShowHide, usrType } = props;
  const [profileEdit, setProfileEdit] = useState(false);
  const [profilePicObj, setProfilePicObj] = useState(null);

  const currentUser = useMemo(() => getCurrentUser(), []);

  // RTK Query hooks
  const { data: userDetailsData } = useGetUserDetailsQuery(currentUser?.id, {
    skip: !currentUser?.id || !!currentUser?.linkUser || !profileShowHide,
  });

  const { data: partnerUserDetailsData } = useGetPartnerUserDetailsQuery(currentUser?.id, {
    skip: !currentUser?.id || !currentUser?.linkUser || !profileShowHide,
  });

  const { data: userProfilePic } = useGetUserProfilePicQuery(currentUser?.id, {
    skip: !currentUser?.id || !profileShowHide,
  });

  const [updateProfileData, { isSuccess: isUpdateSuccess, isError: isUpdateError }] = useUpdateProfileDataMutation();
  const [uploadProfilePic] = useUploadProfilePicMutation();

  const userDetails = useMemo(() => {
    return currentUser?.linkUser ? partnerUserDetailsData : userDetailsData;
  }, [currentUser?.linkUser, partnerUserDetailsData, userDetailsData]);

  const profilePicData = userProfilePic || null;

  // Handle profile details and picture update submission success / error alerts
  useEffect(() => {
    if (isUpdateSuccess) {
      getAlert("", "Updated Successfully", "success");
      setProfilePicObj(null);
      setProfileEdit(false);
    }
  }, [isUpdateSuccess]);

  useEffect(() => {
    if (isUpdateError) {
      getAlert("", "Update Failed", "error");
    }
  }, [isUpdateError]);

  const handleUpdatePic = useCallback(() => {
    if (!profilePicObj || !currentUser?.id) return;
    const frmData = new FormData();
    frmData.append("userId", currentUser.id);
    frmData.append("files[0]", profilePicObj.file);
    uploadProfilePic(frmData);
  }, [profilePicObj, currentUser?.id, uploadProfilePic]);

  const handleSubmit = useCallback((profile) => {
    updateProfileData(profile);
    if (profilePicObj) {
      handleUpdatePic();
    }
  }, [profilePicObj, handleUpdatePic, updateProfileData]);

  const handleImageChange = useCallback((e) => {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      setProfilePicObj({
        file: file,
        fileName: file.name,
        imagePreviewUrl: reader.result,
      });
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  }, []);

  const handleEditProfile = useCallback(() => {
    setProfileEdit((prev) => !prev);
  }, []);

  const handleCancelEdit = useCallback(() => {
    setProfileEdit(false);
    setProfilePicObj(null);
  }, []);

  let $imagePreview = null;
  if (profilePicObj) {
    $imagePreview = (
      <img
        src={profilePicObj.imagePreviewUrl}
        alt="profile"
        style={PROFILE_STYLES.avatarImage}
      />
    );
  } else {
    $imagePreview = (
      <img
        alt="profile"
        style={PROFILE_STYLES.avatarImage}
        src={`${!profilePicData
          ? "../../assets/img/theme/team-4.png"
          : process.env.REACT_APP_API_BASEURL +
          "/ProfilePics/" +
          profilePicData
          }`}
      />
    );
  }

  return (
    <React.Fragment>
      <Modal
        show={profileShowHide}
        size="xl"
        centered
        scrollable
        contentClassName="shadow-none"
      >
        <Modal.Header style={PROFILE_STYLES.modalHeader}>
          <div style={PROFILE_STYLES.headerContent}>
            <Modal.Title as="div" style={PROFILE_STYLES.modalTitleWrap}>
              <div style={PROFILE_STYLES.modalIcon}>
                <i className="fa fa-user-circle-o" aria-hidden="true"></i>
              </div>
              <div>
                <div style={PROFILE_STYLES.modalTitle}>My Profile</div>
                <div style={PROFILE_STYLES.modalSubtitle}>Review and update your account details and profile photo.</div>
              </div>
            </Modal.Title>
            <div style={PROFILE_STYLES.headerActions}>
              {profileEdit && (
                <button
                  type="button"
                  style={PROFILE_STYLES.cancelButton}
                  onClick={handleCancelEdit}
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                  Cancel
                </button>
              )}
              {!profileEdit && (
                <button
                  type="button"
                  style={{ ...PROFILE_STYLES.editButton, ...PROFILE_STYLES.editButtonHeader }}
                  onClick={handleEditProfile}
                >
                  <i className="fa fa-edit" aria-hidden="true"></i>
                  Edit Profile
                </button>
              )}
              <button
                type="button"
                style={PROFILE_STYLES.closeButton}
                onClick={handleProfileShowHide}
                aria-label="Close profile"
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body style={PROFILE_STYLES.modalBody}>
          <div style={PROFILE_STYLES.bodyGrid}>
            <div style={PROFILE_STYLES.avatarPanel}>
              <div style={PROFILE_STYLES.avatarRing}>
                {$imagePreview}
              </div>
              <div style={PROFILE_STYLES.avatarName}>
                {userDetails?.displayName || userDetails?.name || currentUser?.name || "Profile"}
              </div>
              <div style={PROFILE_STYLES.avatarMeta}>
                {userDetails?.email || currentUser?.email || "Update your personal details and profile image from here."}
              </div>
              <div style={PROFILE_STYLES.uploadHint}>
                {profileEdit
                  ? "Choose a new profile photo to update your account."
                  : "Enable edit mode to change your profile picture."}
              </div>
              <div>
                <label
                  style={{
                    ...PROFILE_STYLES.cameraButton,
                    ...(profileEdit ? {} : PROFILE_STYLES.cameraButtonDisabled)
                  }}
                >
                  <input
                    type="file"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                    disabled={!profileEdit}
                  />
                  <i className="fa fa-camera" aria-hidden="true"></i>
                  Change Photo
                </label>
              </div>
            </div>

            <div style={PROFILE_STYLES.detailsPanel}>
              <MyProfileDetails
                userDetails={userDetails}
                handleFormSubmit={handleSubmit}
                profileEdit={profileEdit}
                setProfileEdit={setProfileEdit}
                handleEditProfile={handleEditProfile}
                usrType={usrType}
              ></MyProfileDetails>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer style={PROFILE_STYLES.modalFooter}>
          <div style={PROFILE_STYLES.footerActions}>
            <button
              type="button"
              style={PROFILE_STYLES.cancelButton}
              onClick={handleProfileShowHide}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
